mtl.alloy.factory['toggle-deliveryAddress'] = (function($) {
    'use strict';

    return function(element, options) {

        var $checkbox = $(element);

        var $isSameDeliveryAddress = $checkbox.is(':checked');
        var $deliveryAddressTitle = $('.delivery-address-title');
        var $deliveryAddressFields = $('.delivery-address');

        if(!$isSameDeliveryAddress) {
            $deliveryAddressTitle.show();
            $deliveryAddressFields.show();
        }
        $checkbox.change(function() {
            $deliveryAddressTitle.toggle();
            $deliveryAddressFields.toggle();
        });

    };

}(jQuery));
